import React, {createContext,useState} from "react";


export const PatientContext = createContext();

export const PatientProvider = ({children}) => {

    const [contextData , setContextData ] = useState(null);

    const updatePatientData = (data) => {
        setContextData(data);
        console.log('From Context API ')
        console.log(data)
    };


    return (
        <PatientContext.Provider value={{ contextData, updatePatientData }}>
            {children}
        </PatientContext.Provider>
    );
};